<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      :title="'HMS Kort'"
      :subtitle="'Legg inn HMS kort informasjon'"
      :dialogIcon="'mdi-badge-account-horizontal'"
      :btnActionName="'Lagre'"
      persistent
      @action="checkInpute"
    >
      <template v-slot>
        <p>For å komme inn på byggeplass må HMS-kort legges inn.</p>
        <v-checkbox
          v-model="dontHaveHMSCard"
          label="Jeg har ikke HMS-kort"
        ></v-checkbox>
        <v-form v-if="profile && !dontHaveHMSCard" ref="form" v-model="valid">
          <v-text-field
            v-model="profile.hmsCardNumber"
            prepend-inner-icon="mdi-badge-account-horizontal-outline"
            color="primary"
            label="HMS Kortnummer"
            filled
            hide-details="auto"
            :rules="[(v) => !!v || 'HMS kortnummer må fylles ut!']"
            pattern="[0-9]*"
          ></v-text-field>
          <BirthdayPicker
            v-model="profile.hmsCardIssuedDate"
            label="HMS Utstedt/Gyldig fra"
            :rules="dateRules"
            :min="moment().subtract(2, 'year').format('YYYY-MM-DD')"
          />
        </v-form>
      </template>
    </BaseDialog>
    <ConfirmDialog
      v-model="confirm"
      title="Bekreft"
      subtitle="Jeg har ikke HMS-kort"
      icon="mdi-credit-card-remove-outline"
      text="Er du sikker på at du ikke vil legge inn HMS-kort? <br/> Du vil ikke få fysisk tilgang på prosjektet <br/><br/><br/>"
      btnActionName="Bekreft"
      @action="saveNoHmsCard"
      @close="dontHaveHMSCard = false"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import contactpersonApi from "@/api/contactpersonApi";
// import notification from "@/helpers/notification";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import BirthdayPicker from "@/components/shared/date/BirthdayPicker.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      confirm: false,
      dontHaveHMSCard: false,
      dateRules: [
        (v) => !!v || "Utstedt dato må fylles ut!",
        (v) =>
          moment(moment(v).add(2, "years").format("YYYY-MM-DD")).isBefore(
            moment().format("YYYY-MM-DD")
          ) === false || "Kortet kan ikke være utstedt for mere en 2 år siden!",
      ],
      moment,
    };
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    checkInpute() {
      if (!this.dontHaveHMSCard) {
        const isValid = (this as any).$refs?.form?.validate();
        if (isValid) {
          this.save();
        }
      } else {
        this.confirm = true;
      }
    },
    async save() {
      // const isValid = (this as any).$refs?.form?.validate();

      // if (isValid) {
      var hms = {} as any;
      hms.hmsCardNumber = this.profile.hmsCardNumber;
      hms.hmsCardIssuedDate = this.profile.hmsCardIssuedDate;
      await api.putContactPersonHms(hms).then(async (Response) => {
        await this.updateProfile(Response);
        this.showDialog = false;
        this.$emit("save");
      });
      // } else {
      //   notification.warn("Alle felter må fylles ut!");
      // }
    },
    async saveNoHmsCard() {
      await contactpersonApi.putUserSetting(
        "noHmsCard",
        JSON.stringify(this.dontHaveHMSCard)
      );
      this.confirm = false;
      this.showDialog = false;
      this.$emit("save");
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
    BirthdayPicker,
    ConfirmDialog,
  },
});
</script>
